import { RoundContainer } from 'shared/ui';
import React from 'react';
import { EditOutlined } from '@ant-design/icons';
import ChangeAccountNameDrawer from './ChangeAccountNameDrawer';

const ChangeAccountName: React.FC = () => {
  const [open, setOpen] = React.useState(false);

  const onClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <div
        style={{ flexDirection: 'row', gap: 8, alignItems: 'center' }}
        onClick={() => setOpen(true)}>
        <RoundContainer size={24} pointer color="rgba(0, 0, 0, 0.08)">
          <EditOutlined style={{ fontSize: 15, color: 'rgba(0, 0, 0, 1)' }} />
        </RoundContainer>
      </div>
      <ChangeAccountNameDrawer open={open} onClose={onClose} />
    </div>
  );
};

export default ChangeAccountName;
